import styled from "@emotion/styled";


const colors = {
    title: "#8898AA",
    bgg: "#F4F5F7",
    label: "#525F7F",
    btn: "#40A8E6",
    btnH: "#0F85CB",
    black: "#000",
    alertG: "#67C940",
    alertR: "#E1251B",
    alertY: "#FFD100",
    naranja: "#F55806",
};


export const Card = styled.div`
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  align-items: center;
  max-height: 100%;
  flex: 1 0 auto;
  .title,
  .footer {
    background-color: white;
  }
  .title {
    color: ${colors.title};
  }
  .child {
    background: ${(props) => (props.bgT ? "rgba(0,0,0,.5)" : colors.bgg)};
    width: 100%;
    flex: 0 0 auto;
    padding: 1em 0 0 0;
  }
  
  .back-button{
    background:transparent;
    &:focus{
        outline:none;
    }
  }
  
  @media all and (min-height: 668px){
    .myscroll {
       max-height: calc(100vh - ${props => (props.mxscrol)});
    }

    // 390px
  }
`;
